'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDebouncedValue = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

var _useMountSafeState3 = require('./useMountSafeState');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useDebouncedValue = exports.useDebouncedValue = function useDebouncedValue(value) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

    var _useMountSafeState = (0, _useMountSafeState3.useMountSafeState)(value),
        _useMountSafeState2 = _slicedToArray(_useMountSafeState, 2),
        current = _useMountSafeState2[0],
        _setCurrent = _useMountSafeState2[1];

    var setCurrent = (0, _react.useMemo)(function () {
        return (0, _lodash2.default)(_setCurrent, wait);
    }, [wait]);
    (0, _react.useEffect)(function () {
        setCurrent(value);
    }, [value, setCurrent]);
    return current;
};

exports.default = useDebouncedValue;